/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useInvoiceTipsPostMutation = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.invoiceTips(id),
    mutationFn: (data) => fetcher({ method: "POST", url: `/public/invoice/tips/id/${id}`, data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });
    },
  });
};
